import { useState, useMemo } from "react";

const useFdCalculator = () => {

    const [principal, setPrincipal] = useState(100000);
    const [rate, setRate] = useState(7);
    const [years, setYears] = useState(5);

    const compoundingFrequency = 4;

    const { maturityValue, investedAmount, totalInterest } = useMemo(() => {

        if (principal <= 0 || rate <= 0 || years <= 0) {
            return {
                maturityValue: 0,
                investedAmount: 0,
                totalInterest: 0
            };
        }

        const r = rate / 100;
        const n = compoundingFrequency;

        const futureValue =
            principal * Math.pow(1 + r / n, n * years);

        const roundedValue = Math.round(futureValue);

        return {
            maturityValue: roundedValue,
            investedAmount: principal,
            totalInterest: roundedValue - principal
        };

    }, [principal, rate, years]);

    return {
        title: "FD Calculator",

        inputs: [
            {
                label: "Total Investment",
                value: principal,
                setter: setPrincipal,
                min: 1000,
                max: 10000000,
                step: 1000,
            },
            {
                label: "Rate of Interest (p.a)",
                value: rate,
                setter: setRate,
                min: 1,
                max: 15,
                step: 0.1,
            },
            {
                label: "Time Period (Years)",
                value: years,
                setter: setYears,
                min: 1,
                max: 30,
                step: 1,
            },
        ],

        totalValue: maturityValue,
        investedAmount,
        estimatedReturns: totalInterest,

        infoContent: {
            heading: "FD Calculator – Fixed Deposit",
            description:
                "A Fixed Deposit (FD) calculator helps estimate the maturity value of your lump sum investment using compound interest.",

            subHeading1: "What is a Fixed Deposit?",
            subContent1:
                "A Fixed Deposit is a secure investment option where you deposit a lump sum for a fixed tenure at a predetermined interest rate.",

            subHeading2: "How It Works",
            subContent2:
                "It calculates compound interest (quarterly) on your deposit to determine the final maturity value.",

            formula: "A = P × (1 + r/n)^(n × t)",

            subHeading3: "Benefits",
            benefits: [
                "Low-risk investment option",
                "Guaranteed returns",
                "Flexible tenure choices",
                "Predictable growth",
            ],
        }
    };
};

export default useFdCalculator;